var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:({ maxWidth: _vm.maxWidth + 'px', maxHeight: _vm.maxHeight + 'px' }),attrs:{"src":_vm.src,"alt":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }